import { memo } from 'react';
import { PracticeAnalyticsTypes } from '@frontend/api-analytics';
import { useTranslation } from '@frontend/i18n';
import { formatters } from '@frontend/shared';
import { InlineStats } from '../inline-stats';
import { usePracticeAnalyticsShallowStore } from './hooks/use-practice-analytics-store';

type Props = {
  data?: PracticeAnalyticsTypes.TreatmentPlanTotals;
  isLoading?: boolean;
  isSmallMode?: boolean;
};

export const PractitionerInlineStats = memo(({ data, isLoading, isSmallMode }: Props) => {
  const { t } = useTranslation('analytics');
  const { showDemoChipAndBanner } = usePracticeAnalyticsShallowStore('showDemoChipAndBanner');

  return (
    <InlineStats
      data={[
        {
          key: 'diagnosedPercent',
          name: isSmallMode ? t('Diagnosed') : t('Patients Diagnosed'),
          value: formatters.percent(data?.diagnosedPercent),
        },
        {
          key: 'acceptedPercent',
          name: isSmallMode ? t('Accepted') : t('Patients Accepted'),
          value: formatters.percent(data?.acceptedPercent),
        },
        isSmallMode
          ? null
          : {
              key: 'unscheduledTreatment',
              name: t('Unscheduled Treatment'),
              value: formatters.currency(data?.unscheduledTreatment),
            },
      ]}
      isDemoAccount={showDemoChipAndBanner}
      isLoading={isLoading}
    />
  );
});

PractitionerInlineStats.displayName = 'PractitionerInlineStats';
